import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useApi } from "../Providers/APIProvider";
import { useUser } from "@spt/bezel/src/Providers/UserProvider";
import { KXYear } from "../Models/KXYear";
import { Portal } from "./Portal";
import { LoadingBlock } from "../Components/UI/LoadingBlock";

interface OuterPortalProps {
    SiteAdmins: Array<String> | undefined;
    SetSiteAdmins: Dispatch<SetStateAction<String[] | undefined>>;
}

export function OuterPortal(props: OuterPortalProps) {
    const user = useUser();

    const api = useApi();

    const [Username, setUsername] = useState<string>("");

    const [TAY_AcadYear, setTAY_AcadYear] = useState<string>();
    const [TAY_KXFormat, setTAY_KXFormat] = useState<string>();
    const [TAY_KXYearID, setTAY_KXYearID] = useState<number>();
    const [NAY_AcadYear, setNAY_AcadYear] = useState<string>();
    const [NAY_KXFormat, setNAY_KXFormat] = useState<string>();
    const [NAY_KXYearID, setNAY_KXYearID] = useState<number>();

    useEffect(() => {
        if (TAY_AcadYear !== undefined && TAY_KXFormat === undefined) {
            setTAY_KXFormat(TAY_AcadYear.replace("/", " - 20"));
            // from 2012/13 to Kx academic years are like this: "2012 - 2013"
        }
    }, [TAY_AcadYear]);

    useEffect(() => {
        if (NAY_AcadYear !== undefined && NAY_KXFormat === undefined) {
            setNAY_KXFormat(NAY_AcadYear.replace("/", " - 20"));
            // from 2012/13 to Kx academic years are like this: "2012 - 2013"
        }
    }, [NAY_AcadYear]);

    useEffect(() => {
        api.Accommodation.GetAcademicYears().then(data => {
            if (data !== undefined) {
                setTAY_AcadYear(data.ThisAcadYearKey);
                setNAY_AcadYear(data.NextAcadYearKey);
            }
        });
    }, []);

    useEffect(() => {
        if (TAY_KXFormat !== undefined && TAY_KXYearID === undefined) {
            api.Accommodation.GetKxAcademicYearID(TAY_KXFormat).then(data => { setTAY_KXYearID(data) });
        }
        // from 2012/13 to Kx academic years are like this: "2012 - 2013"
    }, [TAY_KXFormat]);

    useEffect(() => {
        if (NAY_KXFormat !== undefined && NAY_KXYearID === undefined) {
            api.Accommodation.GetKxAcademicYearID(NAY_KXFormat).then(data => { setNAY_KXYearID(data) });
        }
        // from 2012/13 to Kx academic years are like this: "2012 - 2013"
    }, [NAY_KXFormat]);

    useEffect(() => {
        if (user !== undefined) {
            let _u = user.ViewAsUser ?? user.AuthedUser;

            if (_u !== undefined) {
                let actualEmail = _u.userPrincipalName.replace("@essex.ac.uk", "");
                if (actualEmail !== undefined) {
                    setUsername(actualEmail);
                    // console.log("Parsed username as " + actualEmail);
                }
            }
        }
    }, [{ ...user }]);

    if (TAY_AcadYear !== undefined && TAY_KXFormat !== undefined && TAY_KXYearID !== undefined &&
        NAY_AcadYear !== undefined && NAY_KXFormat !== undefined && NAY_KXYearID !== undefined &&
        Username !== undefined && Username !== "") {

        let TAY: KXYear = {
            AcadYear: TAY_AcadYear,
            KXFormat: TAY_KXFormat,
            KXID: TAY_KXYearID
        };

        let NAY: KXYear = {
            AcadYear: NAY_AcadYear,
            KXFormat: NAY_KXFormat,
            KXID: NAY_KXYearID
        };

        return <Portal Ident={Username} ThisAcademicYear={TAY} NextAcademicYear={NAY} Debug={false}
            SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins} />
    } else {
        return <LoadingBlock></LoadingBlock>;
    }
}
